<template>
   <div class="side-menu">
            <div class="contact-us" @mouseenter="mouseFun(true)" @mouseleave="mouseFun(false)">
                <div class="contact-btn" >
                    <img src="@/assets/images/icon/ic_contactus.png" alt="">
                    <span>联<br>系<br>我<br>们</span>
                </div>
                <div class="side-contact" v-show="!topStatus||zxStatus">
                    <div class="contact-content">
                        <div class="contact-list">
                            <img src="@/assets/images/icon/ic_phone.png" alt="">
                            <div class="contact-right">
                                <p class="contact-title">合作热线</p>
                                <p>15600128367</p>
                            </div>
                        </div>
                        <div class="contact-list">
                            <img src="@/assets/images/icon/ic_consult.png" alt="">
                            <div class="contact-right">
                                <p class="contact-title">在线咨询</p>
                                <p>QQ:676791336</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          
            <span  v-show="topStatus" class="go-back" @click="toTopFun">
                <img src="@/assets/images/icon/ic_toparrow.png" alt="">
            </span>
        </div>
</template>

<script >
import { defineComponent,ref, onMounted } from 'vue'
export default defineComponent({
 setup(){
        let topStatus=ref(false) //返回顶部显示与否状态
        let zxStatus=ref(false) //联系我们左侧显示与否
        // 返回顶部
        const toTopFun=()=>{
            let top = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
            const timeTop = setInterval(() => {
                document.body.scrollTop = document.documentElement.scrollTop = top -= 50
                if (top <= 0) {
                    clearInterval(timeTop)
                }
            }, 10)
        }
        
        // 回到顶部按钮是否显示
        const handleScroll= () =>{
            const scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
            scrollTop > 1000 ? (topStatus.value = true) : (topStatus.value = false)
        }
        const mouseFun =(status)=> {
            zxStatus.value = status
        }

        onMounted(()=>{
             window.addEventListener('scroll', handleScroll,false)
        })
     return{
        topStatus,
        toTopFun,
        handleScroll,
        mouseFun,
        zxStatus
     }
 }
})
</script>

<style lang="scss" scoped type="text/scss">
.side-menu{
    position:fixed;
    right:36px;
    bottom:40px;
    height:240px;
    z-index: 199;
}
.contact-us{
    position:relative;
    .contact-btn{
        width: 64px;
        height: 144px;
        padding-top:24px;
        background: #FFFFFF;
        box-shadow: 0px 8px 32px 0px rgba(122, 140, 153, 0.08);
        border-radius: 32px;
        font-size:14px;
        color:#A8ADBB;
        line-height: 20px;
        text-align: center;
        img{
            width:32px;
            height:32px;
            margin:0 auto 8px;
        }
    }
    .side-contact{
        position:absolute;
        right:64px;
        top:0;
        padding-right:16px;
    }
    .contact-content{
        position:relative;
        background: #fff;
        width:138px;
        height:168px;
        padding:0 24px;
        box-shadow: 0px 8px 32px 0px rgba(122, 140, 153, 0.08);
        overflow: hidden;
    }
    .contact-list{
        margin-top:24px;
        overflow: hidden;
        img{
            float:left;
            width:16px;
            height:16px;
            margin-right:8px;
        }
        .contact-right{
            float:left;
            font-size:14px;
            color:#869099;
        }
        .contact-title{
            color:#1B1D1F;
            font-weight:bold;
            margin-bottom:8px;
        }
    }
}
/* go-back */
.go-back {
    display:block;
    width: 64px;
    height: 64px;
    background: #fff;
    border-radius: 32px;
   box-shadow: 0px 8px 32px 0px rgba(122, 140, 153, 0.08);
    overflow: hidden;
    margin-top:8px;
    cursor: pointer;
    img {
        width: 24px;
        height: 24px;
        margin: 20px auto 0;
    }
}
</style>